const text = ['eq', 'neq', 'like', 'notlike', 'ieq', 'nieq'] as const;
const select = ['eq', 'neq'] as const;
const number = ['eq', 'neq', 'lt', 'gt', 'lte', 'gte'] as const;
const routing = [
  'eq',
  'neq',
  'like',
  'notlike',
  'ip',
  'gt',
  'gte',
  'lt',
  'lte',
  'sect',
  'nsect',
] as const;
const ip = ['eq', 'neq', 'like', 'notlike'] as const;
const cidr = ['cidr'] as const;
const uptime = ['eq', 'neq', 'lt', 'gt', 'lte', 'gte'] as const;
const boolean = ['eq', 'neq'] as const;
const asn = ['eq', 'neq', 'lt', 'gt', 'lte', 'gte'] as const;
const dateTime = [
  'eq',
  'neq',
  'lt',
  'gt',
  'lte',
  'gte',
  'nowGt',
  'nowLt',
] as const;

const regex = ['reg', 'nreg', 'ireg', 'nireg'] as const;
const regexCaseSensitive = ['reg', 'nreg'] as const;
const empty = ['emptyTrue', 'emptyFalse'] as const;
const column = ['column', 'ncolumn'] as const;
const color = ['color'] as const;
const arrayContains = ['containsAny', 'containsAll'] as const;

export const filterOperators = {
  text,
  select,
  number,
  routing,
  ip,
  cidr,
  uptime,
  boolean,
  asn,
  regex,
  regexCaseSensitive,
  empty,
  column,
  color,
  dateTime,
  arrayContains,
};
